import { $ } from './dom.js';

const easeOutQuart = (value) => 1 - ((1 - value) ** 4);

export function initPreloader() {
  const preloader = $('#sitePreloader');
  const canvas = $('.site-preloader__canvas', preloader);
  const logo = $('.site-preloader__logo', preloader);
  if (!preloader || !canvas || !logo) return;

  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reducedMotion) return finish(0);

  const context = canvas.getContext('2d', { alpha: false, desynchronized: true });
  const source = new Image();
  source.onload = () => animateParticles(source);
  source.onerror = () => finish(0);
  source.src = logo.currentSrc || logo.src;

  function finish(delay) {
    window.setTimeout(() => {
      preloader.classList.add('is-logo-visible');
      window.setTimeout(() => {
        preloader.classList.add('is-leaving');
        window.setTimeout(() => {
          preloader.classList.add('is-hidden');
          preloader.remove();
        }, 850);
      }, 360);
    }, delay);
  }

  function animateParticles(image) {
    if (!context) return finish(0);
    const density = matchMedia('(pointer: coarse)').matches ? 7 : 5;
    const particleCanvas = document.createElement('canvas');
    const particleContext = particleCanvas.getContext('2d', { willReadFrequently: true });
    const logoWidth = Math.min(310, window.innerWidth * .68);
    const logoHeight = logoWidth * (image.naturalHeight / image.naturalWidth);
    particleCanvas.width = Math.ceil(logoWidth);
    particleCanvas.height = Math.ceil(logoHeight);
    particleContext?.drawImage(image, 0, 0, particleCanvas.width, particleCanvas.height);
    const pixels = particleContext?.getImageData(0, 0, particleCanvas.width, particleCanvas.height).data;
    if (!pixels) return finish(0);

    const particles = [];
    for (let y = 0; y < particleCanvas.height; y += density) {
      for (let x = 0; x < particleCanvas.width; x += density) {
        const offset = (y * particleCanvas.width + x) * 4;
        const red = pixels[offset];
        const green = pixels[offset + 1];
        const blue = pixels[offset + 2];
        const brightness = (red + green + blue) / 3;
        if (brightness < 58 || pixels[offset + 3] < 200) continue;
        particles.push({
          startX: Math.random() * window.innerWidth,
          startY: Math.random() * window.innerHeight,
          targetX: (window.innerWidth - logoWidth) / 2 + x,
          targetY: (window.innerHeight - logoHeight) / 2 + y,
          color: `rgb(${red}, ${green}, ${blue})`,
          size: Math.max(1.15, density * .3),
          delay: Math.random() * .16,
        });
      }
    }

    const ratio = Math.min(window.devicePixelRatio || 1, 1.5);
    canvas.width = Math.floor(window.innerWidth * ratio);
    canvas.height = Math.floor(window.innerHeight * ratio);
    context.setTransform(ratio, 0, 0, ratio, 0, 0);
    const startedAt = performance.now();
    const duration = 1250;

    function draw(now) {
      const progress = Math.min(1, (now - startedAt) / duration);
      context.fillStyle = '#11120f';
      context.fillRect(0, 0, window.innerWidth, window.innerHeight);
      particles.forEach((particle) => {
        const localProgress = Math.min(1, Math.max(0, (progress - particle.delay) / (1 - particle.delay)));
        const eased = easeOutQuart(localProgress);
        context.globalAlpha = Math.min(1, localProgress * 1.45);
        context.fillStyle = particle.color;
        context.beginPath();
        context.arc(
          particle.startX + (particle.targetX - particle.startX) * eased,
          particle.startY + (particle.targetY - particle.startY) * eased,
          particle.size * (0.7 + localProgress * .3),
          0,
          Math.PI * 2,
        );
        context.fill();
      });
      context.globalAlpha = 1;
      if (progress < 1) requestAnimationFrame(draw);
      else finish(120);
    }
    requestAnimationFrame(draw);
  }
}
